import React, {useEffect, useState} from "react";
import InitializePage from '../../lib/server/page'
import Header from "../../components/Layouts/Header";
import HomeFooter from '../../components/Layouts/HomeFooter.jsx';
import { Pagination } from 'antd';
import SubscribeNewsLetter from '../../components/common/subscribenewsletter.jsx';
import ProductCarrousel from '../../components/ForeignRightsProductsCarrousel/ProductCarrousel.jsx';
import NewsCarrousel from '../../components/NewsCarrousel/index.jsx';
import ForeignRightsIntro from '../../components/ForeignRightsIntro/index.jsx';
import HeaderTag from '../../components/meta.jsx';
import { GetForeignRightsPage, getWebTexts} from '../../lib/api/common.jsx';


const ForeignRights = ({foreignRightData, menu, webTexts}) => {  
    
    return (
    <>
        <Header page={'common'} menuSections={menu}/>
        <HeaderTag title="Eccediciones" description="eccediciones" />
        <ForeignRightsIntro introData={foreignRightData?.introText} categoryCTA={foreignRightData?.categoryButtons} pdfURL={foreignRightData?.pdf}/>
        <ProductCarrousel productData={foreignRightData.productsForeignRightsNextReleases} title={"Next Releases"}/>
        <ProductCarrousel productData={foreignRightData.productsForeignRightsCoPrintingList} title={"Next Co-Printing"}/>        
        <NewsCarrousel newsData={foreignRightData.contentForeignRights}/>
        <div class="container line-container"><div class="line6"></div></div>
        <SubscribeNewsLetter webTexts={webTexts}/>
        <HomeFooter />
    </>
  );
};

async function loadData(context){        
    const foreignRightData = await GetForeignRightsPage();    
    return {foreignRightData:foreignRightData?.data}
}

export async function getStaticProps(context) { 
    context.resolvedUrl = "/foreign-rights";
    return InitializePage(context,loadData, true)
}

export default ForeignRights;
